import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

import type { IWbuRichTextProps } from '../WbuRichText.props';

export const props = withCompInfo<IWbuRichTextProps, any>()(
  ['compData', 'experiments'],
  ({ compData, experiments }) => {
    const shouldResolveLinksInPlace = Boolean(
      experiments['specs.thunderbolt.resolveLinksInPlace'],
    );
    return {
      ...compData,
      link: shouldResolveLinksInPlace
        ? compData.link
        : compData.link?.resolvedLink,
    };
  },
);

export default createComponentMapperModel({
  props,
});
